import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import {
  Translations,
  convertStringToArray,
  electOwningCase,
  getProjectStatus,
  isEmptyObject,
  shoudlDisableCancelBtn
} from '../../../utils';
// constant
import { FORM_REFS } from '../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../restClient';
// children
import Dynamicform from '../../common/Dynamicform/dynamicForm';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../common/Modal';
import ActivationNavListNewAccount from './ActivationNavListNewAccount/ActivationNavListNewAccount';
import GlsActivationList from './GlsActivationList';
//action Creator
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
import { cryptoPass } from '../../../utils';
import { updateCasesWithStatus } from '../../createAcase/actions/actionCreator';
import { updateDarkTitleBarCaseStatus } from '../../layouts/actions/actionCreator';
import {
  disableCaseBodyFooterBtn,
  enableCaseBodyFooterBtn,
  setActivationTabData,
  setGenrateSsf,
  setTabsStatus
} from '../actions/actionCreator';

//style
import './styles.css';

class ActivationStatus extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showAccountActivationModal: false,
      disableAccountActivationBtn: true,
      showEchannelActivationModal: false,
      disableEchannelActivationBtn: true,
      showAchCreditActivationModal: false,
      disableAchCreditActivationBtn: true,
      showCorporateCardActivationModal: false,
      disableCorporaeCardActivationBtn: true,
      productsBasicDetails: {},
      currentProductData: undefined,
      showCashFlowForecastingActivationModal: false,
      disableCashFlowForecastingActivationBtn: true,
      pageJson: {}
    };
  }


  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  toggleDialog = () => {
    this.setState({
      showAccountActivationModal: false,
      showEchannelActivationModal: false, showAchCreditActivationModal: false, showCorporateCardActivationModal: false, showCashFlowForecastingActivationModal: false
    });
  }

  getAccountCountryTaxanomy = () => {
    taxonomyHostClient(this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_newAccounts.accountTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          this.setState({ countryList: data.responseData.countryTaxonomy.classificationNodes })
        }
      });

    taxonomyHostClient(this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_echannels.countryTaxonomy))
      .then(({ data }) => {
        this.setState({ currentListCountries: data.responseData.classificationNodes })
      })

    taxonomyHostClient(this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_achCredits.achTaxonomy))
      .then(({ data }) => {
        this.setState({ achCountryList: data.responseData.classificationNodes })
      })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getAccountCountryTaxanomy();
    }
  }

  loadActivationTabState = async () => {
    var _caseId = this.props.owningCase.caseId;
    this.props.blockUi();
    let tab = await cryptoPass('activation-tab',);
    window.sessionStorage.removeItem("tab");
    window.localStorage.setItem('tab', tab);
    eapiClient("/product/activation/case/" + _caseId, { timeout: 420000 })
      .then(({ data, status }) => {
        this.setState({ products: { ...data.responseData } },
        );
        this.props.updateDarkTitleBarCaseStatus(getProjectStatus(this.props.owningCase.caseId, data.responseData.caseStatuses));
        this.props.setTabsStatus('activationTab', data.responseData.tabStatus === "complete");

        const { caseStatuses } = data.responseData;
        this.props.updateCasesWithStatus(caseStatuses);

        // disable/enable cancel case button logic
        if (shoudlDisableCancelBtn(caseStatuses)) {
          this.props.disableCaseBodyFooterBtn('cancelBtn');
        } else {
          this.props.enableCaseBodyFooterBtn('cancelBtn');
        }
        this.props.unBlockUi();
      });
  }

  componentWillMount() {
    aemHostClient("/aemData/formData/json_activation")
      .then(({ data }) => {
        this.setState({ pageJson: data });
        this.getAccountCountryTaxanomy();
      });

    aemHostClient("/aemData/formData/json_gls-approval-comments")
      .then(({ data }) => {
        this.setState({ glsApprovalComments: data.par });
      });

    /*===================Dark title bar page json =================*/
    aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({ data }) => {
        this.setState({ darkTitleBarJson: data.par });
        document.title = `${this.translations(data.par.static_text_darkTitleBar.activation)}- ${'HSBC GLCM'}`
      });

    /*===================Marked signed popup page json =================*/
    aemHostClient("/aemData/formData/json_mark-as-activated-modal-page")
      .then(({ data }) => {
        this.setState({ accountActivationModalPageJson: data });
      });
    /*===================Mark as Activated popup page json =================*/
    aemHostClient("/aemData/formData/json_mark-as-activated-echannel-modal-page")
      .then(({ data }) => {
        this.setState({ echannelActivationModalPageJson: data });
      });
    /*===================Mark as Activated popup page json AcH =================*/
    aemHostClient("/aemData/formData/json_mark-as-activated-achCredits-modal-page")
      .then(({ data }) => {
        this.setState({ achActivationModalPageJson: data });
      });




  }
  componentDidMount() {
    // Loading Activation tab status
    this.loadActivationTabState();
  }

  // Activate click
  _onActivate = () => {
    var apiURL;
    let payLoad = {};
    let finalPayload = {}
    if (this.state.productType === "account") {
      apiURL = "/product/account/" + this.state.currentProductId + "/activation";
      const { hsbcEntity, accountNumber, branchCode } = this.state.productsBasicDetails[this.state.currentProductId];
      finalPayload = { hsbcEntity, accountNumber, branchCode };
      finalPayload.accountId = this.state.currentProductId;
    } else if (this.state.productType === "echannel") {
      apiURL = "/product/echannel/" + this.state.currentProductId + "/activation";
      finalPayload.eChannelId = this.state.productsBasicDetails[this.state.currentProductId].eChannelId;
      finalPayload.eChannel = this.state.currentProductId;
    } else if (this.state.productType === "achCredit") {
      apiURL = "/product/ach-credit/" + this.state.currentProductId + "/activation";
      payLoad.productType = "ach-credit";
      payLoad.achId = this.state.productsBasicDetails[this.state.currentProductId].achId;
      payLoad.id = this.state.currentProductId;
      finalPayload.product = payLoad;
    }
    else if (this.state.productType === "corporateCard") {
      apiURL = "/product/corporate-card/" + this.state.currentProductId + "/activation";
      payLoad.productType = "corporate-card";
      payLoad.corporateCardId = this.state.productsBasicDetails[this.state.currentProductId].corporateCardId;
      payLoad.id = this.state.currentProductId;
      finalPayload.product = payLoad;
    }
    else if (this.state.productType === "cashFlowForecasting") {
      apiURL = "/product/cff/" + this.state.currentProductId + "/activation";
      payLoad.productType = "cff";
      payLoad.cffId = this.state.productsBasicDetails[this.state.currentProductId].cffId;
      payLoad.id = this.state.currentProductId;
      payLoad.isTheProductLive = this.state.productsBasicDetails[this.state.currentProductId].isTheProductLive
      finalPayload.product = payLoad;
    }

    if (!isEmptyObject(finalPayload)) {
      eapiClient(apiURL, {
        method: 'PUT',
        data: JSON.stringify(finalPayload)
      })
        .then(({ status }) => {
          if (status === 200) {
            this.toggleDialog();
            this.loadActivationTabState();
          }
        });
    }
  }

  // Loading current product data
  loadCurrentProductData = (productType, productId) => {
    if (productType === "account") {
      if (this.state.products.account !== undefined && this.state.products.account.length > 0) {
        const { account } = this.state.products;
        this.setState({
          currentProductData: account.find(_account => _account.id === productId),
          productType
        });
      }
    } else if (productType === "echannel") {
      if (this.state.products.echannel !== undefined && this.state.products.echannel.length > 0) {
        const { echannel } = this.state.products;
        this.setState({
          currentProductData: echannel.find(_echannel => _echannel.id === productId),
          productType
        }, () => { this.getBasicDetails(this.state.currentProductData); });
      }
    }
    else if (productType === "achCredit") {
      if (this.state.products.achCredit !== undefined && this.state.products.achCredit.length > 0) {
        const { achCredit } = this.state.products;
        this.setState({
          currentProductData: achCredit.find(_ach => _ach.id === productId),
          productType
        }, () => { this.getBasicDetails(this.state.currentProductData); });
      }
    }
    else if (productType === "corporateCard") {
      if (this.state.products.corporateCard !== undefined && this.state.products.corporateCard.length > 0) {
        const { corporateCard } = this.state.products;
        this.setState({
          currentProductData: corporateCard.find(_cCard => _cCard.id === productId),
          productType
        }, () => { this.getBasicDetails(this.state.currentProductData); });
      }
    }
    else if (productType === "cashFlowForecasting") {
      if (this.state.products.cashFlowForecasting !== undefined && this.state.products.cashFlowForecasting.length > 0) {
        const { cashFlowForecasting } = this.state.products;
        this.setState({
          currentProductData: cashFlowForecasting.find(cffProduct => cffProduct.id === productId),
          productType
        }, () => { this.getBasicDetails(this.state.currentProductData); });
      }
    }
  }

  // open Activation pop up window
  openActivationPopup = (productId, name, productType, title, tempRefId) => {
    this.setState({
      productType,
      currentProductId: productId,
      tempRefId
    });
    this.loadCurrentProductData(productType, productId);
    if (productType === "account") {
      this.setState({ showAccountActivationModal: true });
    } else if (productType === "echannel") {
      this.setState({ showEchannelActivationModal: true });
    }
    else if (productType === "achCredit") {
      this.setState({ showAchCreditActivationModal: true });
    }
    else if (productType === "corporateCard") {
      this.setState({ showCorporateCardActivationModal: true });
    }
    else if (productType === "cashFlowForecasting") {
      this.setState({ showCashFlowForecastingActivationModal: true })
    }
  }

  // Product Edit page
  onProductEdit = (productId, productType, tempRefId) => {
    this.setState({
      productType,
      currentProductId: productId,
      tempRefId
    });
    this.loadCurrentProductData(productType, productId);
    if (productType === "account") {
      this.setState({ showAccountActivationModal: true });
    } else if (productType === "echannel") {
      this.setState({ showEchannelActivationModal: true });
    }
    else if (productType === "achCredit") {
      this.setState({ showAchCreditActivationModal: true });
    }
    else if (productType === "corporateCard") {
      this.setState({ showCorporateCardActivationModal: true });
    }
    else if (productType === "cashFlowForecasting") {
      this.setState({ showCashFlowForecastingActivationModal: true })
    }
  }

  // Basic Details
  getBasicDetails = (basicDetails) => {
    var enableEchannelActivationBtn = false;
    var enableAccountActivationBtn;
    var enableAchActivationBtn = false;
    var enableCCActivationBtn = false;
    if (this.state.productType === "echannel") {
      if (basicDetails.eChannelId && basicDetails.eChannelId !== "") {
        enableEchannelActivationBtn = true;
      } else {
        enableEchannelActivationBtn = false;
      }
    } else if (this.state.productType === "account") {
      if (basicDetails.accountNumber === undefined || basicDetails.accountNumber === "" || basicDetails.branchCode === undefined || basicDetails.branchCode === "") {
        enableAccountActivationBtn = true;
      } else {
        enableAccountActivationBtn = false;
      }
    } if (this.state.productType === "achCredit") {
      if (basicDetails.achId && basicDetails.achId !== "") {
        enableAchActivationBtn = true;
      } else {
        enableAchActivationBtn = false;
      }
    }
    if (this.state.productType === "corporateCard") {
      if (basicDetails.achId && basicDetails.achId !== "") {
        enableCCActivationBtn = true;
      } else {
        enableCCActivationBtn = false;
      }
    }
    if (this.state.productType === "cashFlowForecasting") {
      if (basicDetails.achId && basicDetails.achId !== "") {
        enableCCActivationBtn = true;
      } else {
        enableCCActivationBtn = false;
      }
    }

    let productsBasicDetails = { ...this.state.productsBasicDetails };
    productsBasicDetails[this.state.currentProductId] = basicDetails;
    this.setState({
      productsBasicDetails,
      disableEchannelActivationBtn: enableEchannelActivationBtn,
      disableAccountActivationBtn: enableAccountActivationBtn,
      disableAchCreditActivationBtn: enableAchActivationBtn,
      disableAchCreditActivationBtn: enableAchActivationBtn,
      disableCorporaeCardActivationBtn: enableCCActivationBtn
    });
  }

  // Render mark Activation modal pop up
  renderMarkActivationModalForm = () => {
    var formData, aemform, formRef, pageTitle, hideButtons, setEchanelBtn;

    if (this.state.currentProductData !== undefined) {

      this.state.productType === "account" && this.state.currentProductData.accountNumber === '' ? this.state.currentProductData.accountNumber = 'Live' : this.state.currentProductData.accountNumber
      this.state.productType === "account" && this.state.currentProductData.branchCode === '' ? this.state.currentProductData.branchCode = 'Live' : this.state.currentProductData.branchCode

      if (this.state.productType === 'cashFlowForecasting' && this.state.currentProductData.iscmp && this.state.currentProductData.activationDate) { this.state.currentProductData.isTheProductLive = true } else { this.state.currentProductData.isTheProductLive = false }

      if (this.state.productType === 'corporateCard' && this.state.currentProductData.iscmp && this.state.currentProductData.activationDate && this.state.currentProductData.corporateCardId === undefined) { this.state.currentProductData.corporateCardId = "Live" }

      if (this.state.productType === 'echannel' && this.state.currentProductData.iscmp && this.state.currentProductData.activationDate && this.state.currentProductData.eChannelId === undefined) { this.state.currentProductData.eChannelId = "Live" }

      if (this.state.productType === 'achCredit' && this.state.currentProductData.iscmp && this.state.currentProductData.activationDate && this.state.currentProductData.achId === undefined) { this.state.currentProductData.achId = "Live" }

      formData = { ...this.state.currentProductData };
    }
    if (this.state.productType === "account") {
      hideButtons = true;
      aemform = this.state.accountActivationModalPageJson.par.aemform_markActivated;
      formRef = this.state.accountActivationModalPageJson.par.aemform_markActivated.formRef;
      pageTitle = this.state.accountActivationModalPageJson.par.page_title_mainTitle.pageHeading;
    } else if (this.state.productType === "echannel") {
      hideButtons = false;
      setEchanelBtn = true;
      aemform = this.state.echannelActivationModalPageJson.par.aemform_markActivatedEchannel;
      formRef = this.state.echannelActivationModalPageJson.par.aemform_markActivatedEchannel.formRef;
      pageTitle = this.state.echannelActivationModalPageJson.par.page_title_mainTitle.pageHeading;
    }
    else if (this.state.productType === "achCredit") {
      hideButtons = false;
      setEchanelBtn = true;
      aemform = this.state.achActivationModalPageJson.par.aemform_markActivatedAchCredits;
      formRef = this.state.achActivationModalPageJson.par.aemform_markActivatedAchCredits.formRef;
      pageTitle = this.state.achActivationModalPageJson.par.page_title_mainTitle.pageHeading;
    }
    else if (this.state.productType === "corporateCard") {
      hideButtons = false;
      setEchanelBtn = true;
      aemform = this.state.achActivationModalPageJson.par.aemform_markActivatedCorporateCards;
      formRef = this.state.achActivationModalPageJson.par.aemform_markActivatedCorporateCards.formRef;
      pageTitle = this.state.achActivationModalPageJson.par.page_title_corporateCard.pageHeading;
    }
    else if (this.state.productType === "cashFlowForecasting") {
      hideButtons = false;
      setEchanelBtn = false;
      aemform = this.state.achActivationModalPageJson.par.aemform_markActivatedCashFlowForecasting;
      formRef = this.state.achActivationModalPageJson.par.aemform_markActivatedCashFlowForecasting.formRef;
      pageTitle = this.state.achActivationModalPageJson.par.page_title_cashFlowForecasting.pageHeading;
    }

    const properties = {
      formData,
      editType: 'marked-activation-echannel-pop-up',
      pathname: "/case-body/"
    }

    if (aemform !== undefined && formRef !== undefined) {
      var url = FORM_REFS[formRef];
      return (
        <Dynamicform
          mode={this.state.currentProductData !== undefined ? 'edit' : ''}
          properties={properties}
          pageTitle={pageTitle}
          hideButtons={hideButtons}
          getFormData={this.getBasicDetails}
          onFormSubmit={this._onActivate}
          url={url}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
          setEchanelBtn={setEchanelBtn}
          productType={this.state.productType === "cashFlowForecasting" && "activate-" + this.state.productType}
          isCMP={this.state.currentProductData.iscmp}
        />
      );
    }
  }

  render() {
    let activationJsx;
    if (this.state.products === undefined ||
      this.state.accountActivationModalPageJson === undefined ||
      this.state.echannelActivationModalPageJson === undefined ||
      this.state.achActivationModalPageJson === undefined ||
      this.state.pageJson === undefined) {
      activationJsx = (<h3>Loading...</h3>);
    } else {
      activationJsx = (
        <div>
          {
            this.state.products.account.length > 0
              ? <div className="gdocs-heading-bottom">
                <h3 className="gdoc-activation-heading">{this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_newAccounts.title)}</h3>
                <ActivationNavListNewAccount
                  callEditClick={this.onProductEdit}
                  callPopup={this.openActivationPopup}
                  _pendingActivation={this.translateWord(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_newAccounts.statusText)[1]}
                  _accountActivationModalPageJson={this.state.accountActivationModalPageJson}
                  _pageJson={this.state.pageJson}
                  translateWord={(word) => this.translateWord(word)}
                  translations={(word) => this.translations(word)}
                  type="account"
                  _data={this.state.products}
                  countryList={this.state.countryList}
                />
              </div>
              : ''
          }
          {
            this.state.products.echannel.length > 0
              ? <div className="gdocs-heading-bottom">
                <h3 className="gdoc-activation-heading">{this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_echannels.title)}</h3>
                <ActivationNavListNewAccount
                  callEditClick={this.onProductEdit}
                  callPopup={this.openActivationPopup}
                  _pendingActivation={this.translateWord(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_echannels.statusText)[1]}
                  _echannelActivationModalPageJson={this.state.echannelActivationModalPageJson}
                  _pageJson={this.state.pageJson}
                  translateWord={(word) => this.translateWord(word)}
                  translations={(word) => this.translations(word)}
                  type="echannel"
                  _data={this.state.products}
                  productCountryList={this.state.currentListCountries}
                  newEchannelKey={this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_echannels.new) : ''}
                  existingEchannelKey={this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_echannels.existing) : ''}
                />
              </div>
              : ''
          }
          {
            this.state.products.achCredit.length > 0
              ? <div className="gdocs-heading-bottom">
                <h3 className="gdoc-activation-heading">{this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_achCredits.title)}</h3>
                <ActivationNavListNewAccount
                  callEditClick={this.onProductEdit}
                  callPopup={this.openActivationPopup}
                  _pendingActivation={this.translateWord(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_achCredits.statusText)[1]}
                  _achActivationModalPageJson={this.state.achActivationModalPageJson}
                  _pageJson={this.state.pageJson}
                  translateWord={(word) => this.translateWord(word)}
                  translations={(word) => this.translations(word)}
                  type="achCredit"
                  _data={this.state.products}
                  achCountryList={this.state.achCountries}
                />
              </div>
              : ''
          }
          {
            this.state.products.cashFlowForecasting.length > 0
              ? <div className="gdocs-heading-bottom">
                <h3 className="gdoc-activation-heading">{this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_cashFlowForecasting.title)}</h3>
                <ActivationNavListNewAccount
                  callEditClick={this.onProductEdit}
                  callPopup={this.openActivationPopup}
                  _pendingActivation={this.translateWord(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_cashFlowForecasting.statusText)[1]}
                  _ccActivationModalPageJson={this.state.achActivationModalPageJson}
                  _pageJson={this.state.pageJson}
                  translateWord={(word) => this.translateWord(word)}
                  translations={(word) => this.translations(word)}
                  type="cashFlowForecasting"
                  _data={this.state.products}
                />
              </div>
              : null
          }
          {
            this.state.products.corporateCard.length > 0
              ? <div className="gdocs-heading-bottom">
                <h3 className="gdoc-activation-heading">{this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_corporateCard.title)}</h3>
                <ActivationNavListNewAccount
                  callEditClick={this.onProductEdit}
                  callPopup={this.openActivationPopup}
                  _pendingActivation={this.translateWord(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.status_block_corporateCard.statusText)[1]}
                  _ccActivationModalPageJson={this.state.achActivationModalPageJson}
                  _pageJson={this.state.pageJson}
                  translateWord={(word) => this.translateWord(word)}
                  translations={(word) => this.translations(word)}
                  type="corporateCard"
                  _data={this.state.products}
                />
              </div>
              : ''
          }
          {
            this.state.products.gls.length > 0
              ? (<div className="gdocs-heading-bottom">
                <h3 className="gdoc-activation-heading">{this.translations(this.state.pageJson && this.state.pageJson.par && this.state.pageJson.par.documentation_pack_glsProducts.title)}</h3>
                <GlsActivationList
                  glsProductsList={this.state.products.gls || []}
                  role={this.props.userDetails.roleDetails.role.value}
                  customer={this.props.userDetails.roleDetails.customer}
                  isCIChecker={this.props.userDetails.roleDetails.glsApprover}
                  currentUser={this.props.userDetails}
                  onActionPerformed={this.loadActivationTabState}
                  history={this.props.history}
                  glsApprovalComments={this.state.glsApprovalComments}
                  pageJson={this.state.pageJson}
                  lang={this.props.lang}
                  blockUi={this.props.blockUi}
                  unBlockUi={this.props.unBlockUi}
                />
              </div>
              ) : ''
          }

          <MarkActivateModal
            showDialog={this.state.showAccountActivationModal}
            {...this.state.accountActivationModalPageJson}
            toggleDialog={this.toggleDialog}
            _onActivate={this._onActivate}
            _renderForm={this.renderMarkActivationModalForm()}
            _tempRefId={this.state.tempRefId}
            _productType="account"
            btntext={this.translations(this.state.accountActivationModalPageJson.par.modal_activated.text)}
            disableSubmit={this.state.disableAccountActivationBtn}
            bsClass="gdocs-mark-activated-modal-content"
            translations={(word) => this.translations(word)}
            translateWord={(word) => this.translateWord(word)}
            isCMP={this.state.currentProductData && this.state.currentProductData.iscmp}
          />

          <MarkActivateModal
            showDialog={this.state.showEchannelActivationModal}
            {...this.state.echannelActivationModalPageJson}
            toggleDialog={this.toggleDialog}
            _renderForm={this.renderMarkActivationModalForm()}
            _productType="echannel"
            disableSubmit={this.state.disableEchannelActivationBtn}
            bsClass="gdocs-mark-activated-modal-content"
            translations={(word) => this.translations(word)}
            translateWord={(word) => this.translateWord(word)}
            _tempRefId={this.state.tempRefId}
          />

          <MarkActivateModal
            showDialog={this.state.showAchCreditActivationModal}
            {...this.state.achActivationModalPageJson}
            toggleDialog={this.toggleDialog}
            _renderForm={this.renderMarkActivationModalForm()}
            _productType="achCredit"
            disableSubmit={this.state.disableAchCreditActivationBtn}
            bsClass="gdocs-mark-activated-modal-content"
            translations={(word) => this.translations(word)}
            translateWord={(word) => this.translateWord(word)}
          />

          <MarkActivateModal
            showDialog={this.state.showCorporateCardActivationModal}
            {...this.state.achActivationModalPageJson}
            toggleDialog={this.toggleDialog}
            _renderForm={this.renderMarkActivationModalForm()}
            _productType="corporateCard"
            disableSubmit={this.state.disableAchCreditActivationBtn}
            bsClass="gdocs-mark-activated-modal-content"
            translations={(word) => this.translations(word)}
            translateWord={(word) => this.translateWord(word)}
          />
          <MarkActivateModal
            showDialog={this.state.showCashFlowForecastingActivationModal}
            {...this.state.achActivationModalPageJson}
            toggleDialog={this.toggleDialog}
            _renderForm={this.renderMarkActivationModalForm()}
            _productType="cashFlowForecasting"
            disableSubmit={this.state.disableAchCreditActivationBtn}
            bsClass="gdocs-mark-activated-modal-content"
            translations={(word) => this.translations(word)}
            translateWord={(word) => this.translateWord(word)}
          />
        </div>
      )
    }
    return (
      <div className="gdocs-activation-container">{activationJsx}</div>
    )
  }
}

const MarkActivateModal = (props) => {
  return (
    <Modal
      show={props.showDialog}
      onClose={props.toggleDialog}
      bsClass={props.bsClass}
    >
      {
        props._productType === "corporateCard"
          ? (<ModalHeader title={props.translations(props.par.page_title_corporateCard.pageHeading)} />) :
          props._productType === "cashFlowForecasting" ? (<ModalHeader title={props.translations(props.par.page_title_cashFlowForecasting.pageHeading)} />)
            : (<ModalHeader title={props.translations(props.par.page_title_mainTitle.pageHeading)} />)
      }
      <ModalBody>
        <div>
          {props._renderForm}
        </div>
        {
          props._productType === "account" || props._productType === "echannel"
            ? (<div className="form-group row gdocs-hsbc-reference-container">
              <label className="gdocs-hsbc-reference-lbl">{props.translations(props.par && props.par.modal_activated && props.par.modal_activated.referenceText)}</label>
              <label className="gdocs-hsbc-reference-text">{`(${props.translations(props.par && props.par.modal_activated && props.par.modal_activated.referenceText)}: ${props._tempRefId})`}</label>
            </div>)
            : ''
        }
      </ModalBody>
      {
        (props.btntext) ? (
          <ModalFooter>
            <button
              className="gdocs-btn-primary"
              onClick={props._onActivate}
              disabled={
                props._productType === "account" && props.isCMP ? false :
                  (props.disableSubmit === "true" || props.disableSubmit === true)}
            >
              {props.btntext}
            </button>
          </ModalFooter>
        ) : ''
      }
    </Modal>
  );
}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    lang: state.lang,
    owningCase: electOwningCase(state.cases),
    userDetails: state.auth.userDetails,
    generateSsf: state.generateSsf,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setActivationTabData: activationdata => {
      dispatch(setActivationTabData(activationdata));
    },
    setTabsStatus: (tabName, isComplete) => {
      dispatch(setTabsStatus(tabName, isComplete))
    },
    updateDarkTitleBarCaseStatus: caseStatus => {
      dispatch(updateDarkTitleBarCaseStatus(caseStatus))
    },
    enableCaseBodyFooterBtn: (btnName) => {
      dispatch(enableCaseBodyFooterBtn(btnName))
    },
    disableCaseBodyFooterBtn: (btnName) => {
      dispatch(disableCaseBodyFooterBtn(btnName))
    },
    updateCasesWithStatus: (caseStatuses) => {
      dispatch(updateCasesWithStatus(caseStatuses));
    },
    setGenrateSsf: (generateSsfdata) => {
      dispatch(setGenrateSsf(generateSsfdata))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivationStatus);



// WEBPACK FOOTER //
// ./src/components/CaseBody/Activation/index.js